import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./organisation-config.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./organisation-config.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { of } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertType } from "../../shared/models/alert";
import { OrganisationConfigConstants, organisationConfigHeadingLookup } from "./organisation-config.constants";
import { AppControllerService } from "../../app-controller.service";
import { PopUpComponent } from "../../shared/components/pop-up/pop-up.component";
import { CRUDOperation } from "../../shared/models/crud-operation-enum.model";
import { OrganisationSettingsService } from "../organisations/organisation-settings.service";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { AddOrganisationConfigComponent } from "./add-organisation/add-organisation-config.component";
import { EditOrganisationConfigComponent } from "./edit-organisation/edit-organisation-config.component";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
let OrganisationConfigComponent = class OrganisationConfigComponent {
    appControllerService;
    organisationService;
    changeDetectorRefs;
    modalService;
    selectedOrganisation;
    tableDataSource;
    existingOrganisations;
    tableMapper;
    // public selectedOrganisationName = "";
    heading = OrganisationConfigConstants.PAGE_HEADING;
    removeButtonLabel = OrganisationConfigConstants.REMOVE_BUTTON_LABEL;
    suspendButtonLabel = OrganisationConfigConstants.SUSPEND_BUTTON_LABEL;
    reinstateButtonLabel = OrganisationConfigConstants.REINSTATE_BUTTON_LABEL;
    addButtonLabel = OrganisationConfigConstants.ADD_BUTTON_LABEL;
    editButtonLabel = OrganisationConfigConstants.EDIT_BUTTON_LABEL;
    orgSuspended = false;
    showButtons = false;
    suspendDialogTitle = OrganisationConfigConstants.SUSPEND_ORG_TITLE_TEXT;
    reinstateDialogTitle = OrganisationConfigConstants.REINSTATE_ORG_TITLE_TEXT;
    suspendOrgDialogContent = OrganisationConfigConstants.SUSPEND_ORG_CONTENT_TEXT;
    reinstateOrgDialogContent = OrganisationConfigConstants.UNSUSPEND_ORG_CONTENT_TEXT;
    serverErrorObjectName = OrganisationConfigConstants.SERVER_ERROR_OBJECT_NAME;
    organisationId;
    tableSelection = [];
    selectOneOrgMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    orgSuspendedMessage = `Organisation ${SharedConstants.ITEM_SUSPENDED}`;
    deleteSuccessMessage = OrganisationConfigConstants.DELETE_SUCCESS_TEXT;
    suspendSuccessMessage = OrganisationConfigConstants.SUSPEND_SUCCESS_TEXT;
    reinstateSuccessMessage = OrganisationConfigConstants.UNSUSPEND_SUCCESS_TEXT;
    selectOrgMessage = SharedConstants.NO_ITEM_SELECTED;
    unknownOrganisation = SharedConstants.UNKNOWN_ORGANISATION;
    cantSuspendSysAdminMessage = OrganisationConfigConstants.IS_ADMIN_TEXT;
    orgAlreadySuspendedMessage = OrganisationConfigConstants.ORG_ALREADY_SUSPENDED_TEXT;
    orgIsNotSuspendedMessage = OrganisationConfigConstants.ORG_IS_NOT_SUSPENDED_TEXT;
    moreThanOneOrgSelectedMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    addModalTitle = OrganisationConfigConstants.ADD_ORGANISATION_TITLE;
    editModalTitle = OrganisationConfigConstants.EDIT_ORGANISATION_TITLE;
    getOrganisationsSubscription;
    suspendOrganisationSubscription;
    reinstateOrganisationSubscription;
    constructor(appControllerService, organisationService, changeDetectorRefs, modalService) {
        this.appControllerService = appControllerService;
        this.organisationService = organisationService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.modalService = modalService;
        this.initializeColumnToObjectMapping();
    }
    ngOnInit() {
        this.getOrganisations();
    }
    getOrganisations() {
        this.getOrganisationsSubscription =
            this.organisationService.getOrganisations().subscribe(organisations => {
                //@ts-ignore
                this.tableDataSource = of(organisations.value);
                this.changeDetectorRefs.detectChanges();
            });
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = organisationConfigHeadingLookup;
    }
    onBtnSuspendClicked() {
        if (this.tableSelection.length === 0) {
            this.appControllerService.showMessage(this.selectOrgMessage, AlertType.Warning);
            return;
        }
        if (this.tableSelection.length === 1 && this.tableSelection[0].suspended) {
            this.appControllerService.showMessage(this.orgAlreadySuspendedMessage, AlertType.Warning);
            return;
        }
        if (this.tableSelection.length > 1) {
            this.appControllerService.showMessage(this.moreThanOneOrgSelectedMessage, AlertType.Warning);
            return;
        }
        this.selectedOrganisation = this.tableSelection[0];
        const modalOptions = this.organisationService.getModalOptions(SharedConstants.MODAL_SIZE.small);
        const suspendedOrg = this.tableSelection[0];
        const title = this.suspendDialogTitle;
        const contentMessage = this.suspendOrgDialogContent;
        const dialogRef = this.modalService.open(PopUpComponent, modalOptions);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = suspendedOrg;
        dialogRef.result.then((orgSuspended) => {
            if (orgSuspended) {
                this.suspendOrganisationSubscription = this.organisationService.suspendOrganisation(orgSuspended.id).subscribe((response) => {
                    this.updateInitialOrganisations(true);
                    this.appControllerService.showMessage(this.suspendSuccessMessage, AlertType.Success);
                }, (error) => {
                    if (error.status === 400 || error.status === 404) {
                        this.appControllerService.showMessage(error.error.value, AlertType.Warning);
                    }
                    else {
                        this.appControllerService.handleServerErrorMessage(this.serverErrorObjectName, error, CRUDOperation.Update);
                    }
                });
            }
        });
    }
    onBtnReinstateClicked() {
        if (this.tableSelection.length === 0) {
            this.appControllerService.showMessage(this.selectOrgMessage, AlertType.Warning);
            return;
        }
        if (this.tableSelection.length === 1 && !this.tableSelection[0].suspended) {
            this.appControllerService.showMessage(this.orgIsNotSuspendedMessage, AlertType.Warning);
            return;
        }
        if (this.tableSelection.length > 1) {
            this.appControllerService.showMessage(this.moreThanOneOrgSelectedMessage, AlertType.Warning);
            return;
        }
        this.selectedOrganisation = this.tableSelection[0];
        const suspendedOrg = this.tableSelection[0];
        const modalOptions = this.organisationService.getModalOptions(SharedConstants.MODAL_SIZE.small);
        const dialogRef = this.modalService.open(PopUpComponent, modalOptions);
        dialogRef.componentInstance.title = this.reinstateDialogTitle;
        dialogRef.componentInstance.contentMessage = this.reinstateOrgDialogContent;
        dialogRef.componentInstance.data = suspendedOrg;
        dialogRef.result.then((organisationSuspended) => {
            if (organisationSuspended) {
                this.reinstateOrganisationSubscription = this.organisationService.reinstateOrganisation(organisationSuspended.id).subscribe((response) => {
                    this.selectedOrganisation.suspended = false;
                    // this.changeDetectorRefs.markForCheck();
                    this.updateInitialOrganisations(false);
                    this.appControllerService.showMessage(this.reinstateSuccessMessage, AlertType.Success);
                }, (error) => {
                    if (error.status === 400 || error.status === 404) {
                        this.appControllerService.showMessage(error.error.value, AlertType.Warning);
                    }
                    else {
                        this.appControllerService.handleServerErrorMessage(this.serverErrorObjectName, error, CRUDOperation.Update);
                    }
                });
            }
        });
    }
    updateInitialOrganisations(isSuspended) {
        const organisations = this.appControllerService.organisationsSubject.getValue();
        const updateOrganisationModules = organisations.map(organisation => {
            if (organisation.id === this.selectedOrganisation.id) {
                organisation.suspended = isSuspended;
            }
            return organisation;
        });
        this.appControllerService.organisationsSubject
            .next(updateOrganisationModules.sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1)));
        this.orgSuspended = false;
        this.showButtons = false;
        this.selectedOrganisation = null;
        this.getOrganisations();
    }
    onBtnAddClicked() {
        const modalOptions = this.getModalOptions(SharedConstants.MODAL_SIZE.extraLarge);
        const modalRef = this.modalService.open(AddOrganisationConfigComponent, modalOptions);
        modalRef.componentInstance.modalTitle = this.addModalTitle;
        modalRef.componentInstance.existingOrganisatons = this.existingOrganisations;
        modalRef.result.then(refreshSurveys => {
            if (refreshSurveys) {
                this.getOrganisations();
            }
        }).catch((res) => {
        });
    }
    onBtnEditClicked() {
        if (this.tableSelection.length === 0) {
            this.appControllerService.showMessage(this.selectOrgMessage, AlertType.Warning);
            return;
        }
        if (this.tableSelection.length > 1) {
            this.appControllerService.showMessage(this.moreThanOneOrgSelectedMessage, AlertType.Warning);
            return;
        }
        const selectedOrganisation = this.tableSelection[0];
        const modalOptions = this.getModalOptions(SharedConstants.MODAL_SIZE.extraLarge);
        const modalRef = this.modalService.open(EditOrganisationConfigComponent, modalOptions);
        modalRef.componentInstance.modalTitle = this.editModalTitle;
        modalRef.componentInstance.orgId = selectedOrganisation.id;
        modalRef.componentInstance.existingOrganisations = this.existingOrganisations;
        modalRef.result.then(refreshUsers => {
            if (refreshUsers) {
                this.getOrganisations();
            }
        }).catch((res) => {
        });
    }
    arrayReturned(array) {
        this.tableSelection = array;
        this.showOrHideSuspendButtons(array);
    }
    showOrHideSuspendButtons(selectedItems) {
        if (selectedItems !== undefined) {
            if (selectedItems.length !== 1) {
                this.showButtons = false;
            }
            else {
                this.orgSuspended = selectedItems[0].suspended;
                this.showButtons = true;
            }
            this.changeDetectorRefs.markForCheck();
        }
    }
    getModalOptions(modalSize) {
        return { size: modalSize, centered: true, keyboard: false, backdrop: "static" };
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: OrganisationSettingsService },
        { type: ChangeDetectorRef },
        { type: NgbModal }
    ];
};
OrganisationConfigComponent = __decorate([
    Component({
        selector: "app-organisation-config",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], OrganisationConfigComponent);
export { OrganisationConfigComponent };
